var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 7.553 9.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_506",
    "data-name": "\\u7EC4 506",
    transform: "translate(-3403.462 -640.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_505",
    "data-name": "\\u7EC4 505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_39",
    "data-name": "\\u8DEF\\u5F84 39",
    d: "M3407.041,640.545h.4c.029.005.058.009.087.015.206.041.416.066.616.127a2.857,2.857,0,0,1,1.367.942,2.669,2.669,0,0,1,.655,1.642c.018.453.011.907.014,1.361,0,.035,0,.069,0,.111h.165a.622.622,0,0,1,.671.667q0,1.848,0,3.7a.755.755,0,0,1-.062.313.62.62,0,0,1-.614.359q-2.994,0-5.986,0c-.087,0-.174,0-.261,0a.619.619,0,0,1-.377-.127.66.66,0,0,1-.25-.561q0-1.83,0-3.66c0-.036,0-.072,0-.108a.612.612,0,0,1,.586-.574c.08,0,.16,0,.246,0v-.113c0-.37,0-.739,0-1.109a3.121,3.121,0,0,1,.138-.94,2.881,2.881,0,0,1,.707-1.148,2.78,2.78,0,0,1,1.373-.8C3406.691,640.6,3406.867,640.574,3407.041,640.545Zm1.868,4.193a.193.193,0,0,0,.007-.032c0-.45.011-.9-.009-1.351a1.542,1.542,0,0,0-.132-.547,1.673,1.673,0,0,0-3.188.424c-.039.492-.018.99-.023,1.485a.066.066,0,0,0,.009.021Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFilled);
export default __webpack_public_path__ + "static/media/lock_filled.bfa7ad01571e54f9ccd30b5daf82c799.svg";
export { ForwardRef as ReactComponent };